import React from 'react';
import { useCookieConsent } from '../hooks/useCookieConsent';

const CookieBanner = () => {
  const {
    isBannerVisible,
    acceptAll,
    acceptNecessaryOnly,
    openSettingsModal,
  } = useCookieConsent();

  if (!isBannerVisible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie使用同意バナー"
      className="fixed bottom-0 left-0 right-0 z-40 p-4 sm:p-6 bg-white border-t border-gray-200 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {/* Text */}
        <div className="text-sm text-gray-700 leading-relaxed max-w-3xl">
          <p>
            Billwaveではサービスの提供および利用状況の分析のためCookieを利用しています。
            詳細は{' '}
            <a
              href="/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800 font-medium"
            >
              Cookieポリシー
            </a>{' '}
            をご確認ください。
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-wrap items-center gap-3 shrink-0">
          <button
            onClick={openSettingsModal}
            className="text-sm font-medium text-gray-600 underline hover:text-blue-600 py-2 px-1 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
          >
            Cookie設定
          </button>
          <button
            onClick={acceptNecessaryOnly}
            className="text-sm font-semibold text-gray-700 bg-gray-100 border border-gray-300 hover:bg-gray-200 py-2 px-4 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            必要なCookieのみ
          </button>
          <button
            onClick={acceptAll}
            className="text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 py-2 px-4 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            すべて許可
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
